module.exports = __webpack_public_path__ + "img/8b984704710dbf884656d644b42724fe.png";